import { Modal, Button, WingBlank, WhiteSpace, Toast } from 'antd-mobile';
import { appMethod as app } from '@utils/app';

import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import OfficialPage from '../OfficialPage';

import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';
import { TopNav } from '@common/top-nav/TopNav';
import './CouponList.less';

const prompt = Modal.prompt;

export default class CouponList extends OfficialPage {
  state = {
    topNavBarData: {
      isDefault: 0,
      title: '优惠券'
    },
    type: 1,
    loadData: {
      currentPage: 1,
      isMore: 1,
      loading: false
    },
    hiddenmodalput: true,
    untimes: '', // 次数券的次数
    numberOfStampsUrl: '',
    couponList: [],
    addLabelText: '',
    rechargeSuccess: 0,
    storeStyle: {}
  }

  constructor(props) {
    super(props);
    document.title = '优惠券';
  }

  componentDidMount() {
    let _this = this
    let isParent = app.globalData.hasFranchiseeList
    _this.setData({
      isParentShop: isParent,
      'topNavBarData.totalHeight': app.globalData.topNavBarHeight || 0
    })
    if (isParent) {
      _this.getLocation()
    } else {
      _this.getAppECStoreConfig()
      _this.getMyCoupons()
    }
  }

  changeTab = event => {
    let _this = this
    let type = event.target.dataset.type
    _this.setData({
      type: type,
      couponList: [],
      loadData: {
        currentPage: 1,
        isMore: 1,
        loading: false
      }
    })
    if (_this.data.isParentShop) {
      _this.getMyAllCoupons()
    } else {
      _this.getMyCoupons()
    }
  }
  getMyCoupons = () => {
    let _this = this
    if (_this.data.loadData.isMore == 0 || _this.data.loadData.loading) {
      return false
    }
    _this.setData({
      'loadData.loading': true
    })
    app.sendRequest({
      url: '/index.php?r=AppShop/getMyCoupons',
      data: {
        type: _this.data.type,
        page: _this.data.loadData.currentPage,
        page_size: 10
      },
      hideLoading: true,
      success: function(res) {
        _this.setData({
          couponList: _this.data.couponList.concat(res.data),
          'loadData.currentPage': (res.current_page || 0) + 1,
          'loadData.isMore': res.is_more,
          'loadData.loading': false
        })
      }
    })
  }
  getMyAllCoupons = () => {
    let _this = this
    if (_this.data.loadData.isMore == 0 || _this.data.loadData.loading) {
      return false
    }
    _this.setData({
      'loadData.loading': true
    })
    app.sendRequest({
      url: '/index.php?r=AppShop/GetMyAllCoupons',
      data: {
        type: _this.data.type,
        latitude: _this.data.latitude,
        longitude: _this.data.longitude,
        page: _this.data.loadData.currentPage,
        page_size: 10
      },
      hideLoading: true,
      success: function(res) {
        _this.setData({
          couponList: _this.data.couponList.concat(res.data),
          'loadData.currentPage': (res.current_page || 0) + 1,
          'loadData.isMore': res.is_more,
          'loadData.loading': false
        })
      }
    })
  }
  getLocation = () => {
    let that = this
    app.getLocation({
      success: function(res) {
        that.setData({
          longitude: res.longitude,
          latitude: res.latitude
        })
        that.getMyAllCoupons()
      },
      fail: function() {
        that.setData({
          longitude: '',
          latitude: ''
        })
        that.getMyAllCoupons()
      }
    })
  }
  gotoCouponDetail = event => {
    let couponId = event.currentTarget.dataset.id
    let appid = event.currentTarget.dataset.appid
    let franisee = ''
    if (app.globalData.appId != appid && this.data.isParentShop) {
      franisee = '&franchisee=' + appid
    }
    let url =
      '/pages/couponDetail/couponDetail?status=use&detail=' +
      couponId +
      franisee
    app.turnToPage(url, false)
  }
  gotoTransferPage = () => {
    let url = '/eCommerce/pages/transferPage/transferPage'
    app.turnToPage(url, false)
  }
  addLabelInputChange = e => {
    this.setData({ addLabelText: e.target.value })
  }
  gotoNumberPage = event => {
    event.stopPropagation();
    let couponId = event.currentTarget.dataset.id
    let appid = event.currentTarget.dataset.appid
    let untimes = event.currentTarget.dataset.untimes
    let franisee = ''
    if (app.globalData.appId != appid && this.data.isParentShop) {
      franisee = '&franchisee=' + appid
    }
    let url =
      '/exchangeCoupon/pages/numberOfStampsUsed/numberOfStampsUsed?detail=' +
      couponId +
      franisee
    this.setData({
      numberOfStampsUrl: url,
      hiddenmodalput: false,
      untimes: untimes
    })
  }
  confirm = () => {
    if (+this.data.untimes < +this.data.addLabelText) {
      app.showModal({ content: '核销次数超过剩余次数' })
      this.setData({ hiddenmodalput: true, addLabelText: '' })
      return
    }
    let url = this.data.numberOfStampsUrl + '&Number=' + this.data.addLabelText
    this.setData({ hiddenmodalput: true, addLabelText: '' })
    app.turnToPage(url, false)
  }
  cancel = () => {
    this.setData({ hiddenmodalput: true, addLabelText: '' })
  }
  gotoRecharge = event => {
    event.stopPropagation();
    let _this = this
    let userCouponId = event.currentTarget.dataset.id
    app.sendRequest({
      url: '/index.php?r=AppShop/useCoupon',
      data: {
        user_coupon_id: userCouponId
      },
      hideLoading: true,
      success: function(res) {
        _this.setData({
          rechargeSuccess: 1
        })
        setTimeout(function() {
          _this.hideToast()
        }, 3000)
        let couponList = _this.data.couponList
        for (var i = 0; i < couponList.length; i++) {
          if (couponList[i]['id'] == userCouponId) {
            let newData = {}
            newData['couponList[' + i + '].status'] = 2
            _this.setData(newData)
          }
        }
      }
    })
  }
  hideToast = () => {
    this.setData({
      rechargeSuccess: 0
    })
  }
  gotoShop = e => {
    e.stopPropagation();
    let appid = e.currentTarget.dataset.appid
    let mode = e.currentTarget.dataset.mode
    let chainId = app.getChainId()
    if (app.globalData.appId == appid) {
      if (app.getChainId()) {
        app.clearChainInfo()
      }
      let home = app.getHomepageRouter()
      app.reLaunch({
        url: '/pages/' + home + '/' + home
      })
    } else if (chainId == appid) {
      let home = app.getHomepageRouter()
      app.reLaunch({
        url: '/pages/' + home + '/' + home
      })
    } else {
      let param = {}
      param.detail = appid
      app.goToFranchisee(mode, param)
    }
  }
  getAppECStoreConfig = () => {
    app.getAppECStoreConfig(res => {
      this.setData({
        storeStyle: res.color_config
      })
    })
  }

  privateStopNoop(e) {
    e.stopPropagation()
  }

  render() {
    const {
      showGetUserInfo,
      topNavBarData,
      type,
      storeStyle,
      couponList,
      isParentShop,
      rechargeSuccess,
      hiddenmodalput,
      addLabelText,
      labelFocus
    } = this.state
    return (
      <div className="official-page coupon-list">
        <TopNav title="优惠券" />
        <div id="coupon-list">
          <div
            className="tabs"
            style={convertLineStyleData('top:' + topNavBarData.totalHeight + 'px;')}
          >
            <div className="tabs-wrap">
              <div
                data-type="1"
                onClick={this.changeTab}
                style={convertLineStyleData(
                  type == 1
                    ? 'color:' +
                    storeStyle.theme +
                    ';border-color:' +
                    storeStyle.theme
                    : ''
                )}
                className={type == 1 ? 'active' : ''}
              >
                未使用
              </div>
              <div
                data-type="2"
                onClick={this.changeTab}
                style={convertLineStyleData(
                  type == 2
                    ? 'color:' +
                    storeStyle.theme +
                    ';border-color:' +
                    storeStyle.theme
                    : ''
                )}
                className={type == 2 ? 'active' : ''}
              >
                已使用
              </div>
              <div
                data-type="3"
                onClick={this.changeTab}
                style={convertLineStyleData(
                  type == 3
                    ? 'color:' +
                    storeStyle.theme +
                    ';border-color:' +
                    storeStyle.theme
                    : ''
                )}
                className={type == 3 ? 'active' : ''}
              >
                已失效
              </div>
            </div>
          </div>
          {isParentShop ? (
            <React.Fragment>
              <ScrollView className="ticket-list" scroll-y="true" lower-threshold="100" bindscrolltolower={this.getMyAllCoupons}>
                {couponList.map((coupon, index) => {
                  return (
                    <React.Fragment key={coupon.id}>
                      <div
                        className="ticket franchisee-ticket"
                        onClick={this.gotoCouponDetail}
                        data-id={coupon.id}
                        data-appid={coupon.app_id}
                      >
                        <div
                          className="top-section"
                          style={convertLineStyleData('border-color:' + coupon.list_color)}
                        >
                          <div className="coupon-franchisee">
                            <img
                              className="coupon-franchisee-logo"
                              mode="aspectFill"
                              src={coupon.logo}
                            />
                              <div
                                className="coupon-franchisee-name"
                                onClick={this.gotoShop}
                                data-mode={coupon.app_shop_info.mode_id}
                                data-appid={coupon.app_id}
                              >
                                {coupon.app_shop_info.name}
                                <label className="ico-moon icon-rightarrow"></label>
                              </div>
                              <div className="coupon-franchisee-distance">
                                {'附近' + coupon.app_shop_info.distance + '米'}
                              </div>
                          </div>
                          {coupon.type == 0 ? (
                            <React.Fragment>
                              <div className="detail-info-franchisee">
                                <div
                                  className="coupon-value"
                                  style={convertLineStyleData('color:' + coupon.list_color)}
                                >
                                  <label>¥</label>
                                  {coupon.value}
                                </div>
                                <div className="coupon-condition">
                                  {'满' + coupon.condition + '可用'}
                                </div>
                              </div>
                            </React.Fragment>
                          ) : coupon.type == 1 ? (
                            <React.Fragment>
                              <div className="detail-info-franchisee">
                                <div
                                  className="coupon-value"
                                  style={convertLineStyleData('color:' + coupon.list_color)}
                                >
                                  {coupon.value}
                                  <label>折</label>
                                </div>
                                {coupon.extra_goods == 'null' ? (
                                  <div className="coupon-condition">
                                    全部商品可享优惠
                                  </div>
                                ) : (
                                  <div className="coupon-condition">
                                    部分商品可享优惠
                                  </div>
                                )}
                              </div>
                            </React.Fragment>
                          ) : coupon.type == 2 ? (
                            <React.Fragment>
                              <div className="detail-info-franchisee">
                                <div
                                  className="coupon-value"
                                  style={convertLineStyleData('color:' + coupon.list_color)}
                                >
                                  <label>¥</label>
                                  {coupon.value}
                                </div>
                                <div className="coupon-condition">
                                  商品代金券
                                </div>
                              </div>
                            </React.Fragment>
                          ) : coupon.type == 3 ? (
                            <React.Fragment>
                              <div className="detail-info-franchisee">
                                <div
                                  className="coupon-value"
                                  style={convertLineStyleData('color:' + coupon.list_color)}
                                >
                                  兑换券
                                </div>
                                {coupon.extra_condition == '' ? (
                                  <div className="coupon-condition">
                                    {'直接兑换' +
                                    coupon.coupon_goods_info.title}
                                  </div>
                                ) : coupon.extra_condition.price ? (
                                  <div className="coupon-condition">
                                    {'消费满' +
                                    coupon.extra_condition.price +
                                    '元可兑换' +
                                    coupon.coupon_goods_info.title}
                                  </div>
                                ) : (
                                  coupon.extra_condition.goods_id && (
                                    <div className="coupon-condition">
                                      {'购买' +
                                      coupon.condition_goods_info.title +
                                      '可兑换' +
                                      coupon.coupon_goods_info.title}
                                    </div>
                                  )
                                )}
                              </div>
                            </React.Fragment>
                          ) : coupon.type == 4 ? (
                            <React.Fragment>
                              <div className="detail-info-franchisee">
                                <div
                                  className="coupon-value"
                                  style={convertLineStyleData('color:' + coupon.list_color)}
                                >
                                  <label>¥</label>
                                  {coupon.value}
                                </div>
                                <div className="coupon-condition">
                                  商品储值金
                                </div>
                              </div>
                            </React.Fragment>
                          ) : coupon.type == 5 ? (
                            <React.Fragment>
                              <div className="detail-info-franchisee">
                                <div
                                  className="coupon-value"
                                  style={convertLineStyleData('color:' + coupon.list_color)}
                                >
                                  通用券
                                </div>
                                <div className="coupon-condition">
                                  {coupon.extra_condition}
                                </div>
                              </div>
                            </React.Fragment>
                          ) : (
                            coupon.type == 6 && (
                              <React.Fragment>
                                <div className="detail-info-franchisee">
                                  <div className="coupon-value">次数券</div>
                                  <div className="coupon-condition">
                                    {'使用条件: 可使用' +
                                    coupon.verify_times +
                                    '次'}
                                  </div>
                                </div>
                              </React.Fragment>
                            )
                          )}
                          {coupon.status == 1 && (
                            <div
                              className="receive-btn"
                              onClick={this.gotoShop}
                              data-appid={coupon.app_id}
                              data-mode={coupon.app_shop_info.mode_id}
                              style={convertLineStyleData('background-color:' + coupon.list_color)}
                            >
                              去使用
                            </div>
                          )}
                          {coupon.status == 2 && (
                            <div className="receive-btn receive-btn-use">
                              已使用
                            </div>
                          )}
                          {coupon.status == 3 && (
                            <div className="receive-btn receive-btn-use">
                              已失效
                            </div>
                          )}
                        </div>
                        <div className="bottom-section">
                          <div>
                            {'有效期 ' +
                            (coupon.expire == '-1'
                              ? coupon.start_use_date +
                              '至' +
                              coupon.end_use_date
                              : coupon.expire == '0'
                                ? '领取当天生效,有效期1天'
                                : '领取' +
                                (coupon.react > 0
                                  ? coupon.react + '天后'
                                  : '当天') +
                                '生效，有效期' +
                                coupon.expire +
                                '天') +
                            (coupon.exclude_holiday == 0
                              ? ''
                              : '除去法定节假日') +
                            ' ' +
                            (coupon.exclude_weekend == 0
                              ? ''
                              : '周一至周五') +
                            ' ' +
                            coupon.start_use_time +
                            '-' +
                            coupon.end_use_time}
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                )
                })}
              </ScrollView>
                </React.Fragment>
                ) : (
                    <React.Fragment>
                      <ScrollView className="ticket-list" scroll-y="true" lower-threshold="100" bindscrolltolower={this.getMyCoupons}>
                        {couponList.map((coupon, index) => {
                          return (
                            <React.Fragment key={coupon.id}>
                              <div
                                className={
                                  'ticket ' +
                                  (coupon.status == 2 ||
                                  coupon.status == 3 ||
                                  coupon.status == 4
                                    ? 'expired'
                                    : '')
                                }
                                onClick={this.gotoCouponDetail}
                                data-id={coupon.id}
                              >
                                {coupon.type == 0 ? (
                                  <div
                                    className="top-section"
                                    style={convertLineStyleData('border-color:' + coupon.list_color)}
                                  >
                                    <div className="detail-info">
                                      <div className="name">{coupon.title}</div>
                                      <div className="use-condition">
                                        {'使用条件：满' +
                                        coupon.condition +
                                        '元，减' +
                                        coupon.value +
                                        '元'}
                                      </div>
                                    </div>
                                    <div
                                      className="background-word-area"
                                      style={convertLineStyleData('border-color:' + coupon.list_color)}
                                    >
                                      <div
                                        className="background-circle"
                                        style={convertLineStyleData('background-color:' + coupon.list_color)}
                                      ></div>
                                      <div className="background-word">减</div>
                                    </div>
                                    {/*  <view wx:if="{{ coupon.status == 1 }}" class="use-btn" catchtap="gotoTransferPage" style={convertLineStyleData('{{ 'background-color:' + coupon.list_color }}')}>立即买单</view>  */}
                                    {coupon.status == 2 ? (
                                      <div className="use-btn">已使用</div>
                                    ) : (
                                      coupon.status == 3 && (
                                        <div className="use-btn">已失效</div>
                                      )
                                    )}
                                  </div>
                                ) : coupon.type == 1 ? (
                                  <div
                                    className="top-section"
                                    style={convertLineStyleData('border-color:' + coupon.list_color)}
                                  >
                                    <div className="detail-info">
                                      <div className="name">{coupon.title}</div>
                                      <div className="use-condition">
                                        {'使用条件: 打' + coupon.value + '折'}
                                      </div>
                                    </div>
                                    <div
                                      className="background-word-area"
                                      style={convertLineStyleData('border-color:' + coupon.list_color)}
                                    >
                                      <div
                                        className="background-circle"
                                        style={convertLineStyleData('background-color:' + coupon.list_color)}
                                      ></div>
                                      <div className="background-word">折</div>
                                    </div>
                                    {/*  <view wx:if="{{ coupon.status == 1 }}" class="use-btn" catchtap="gotoTransferPage" style={convertLineStyleData('{{ 'background-color:' + coupon.list_color }}')}>立即买单</view>  */}
                                    {coupon.status == 2 ? (
                                      <div className="use-btn">已使用</div>
                                    ) : (
                                      coupon.status == 3 && (
                                        <div className="use-btn">已失效</div>
                                      )
                                    )}
                                  </div>
                                ) : coupon.type == 2 ? (
                                  <div
                                    className="top-section"
                                    style={convertLineStyleData('border-color:' + coupon.list_color)}
                                  >
                                    <div className="detail-info">
                                      <div className="name">{coupon.title}</div>
                                      <div className="use-condition">
                                        {'使用条件：可抵扣' + coupon.value + '元'}
                                      </div>
                                    </div>
                                    <div
                                      className="background-word-area"
                                      style={convertLineStyleData('border-color:' + coupon.list_color)}
                                    >
                                      <div
                                        className="background-circle"
                                        style={convertLineStyleData('background-color:' + coupon.list_color)}
                                      ></div>
                                      <div className="background-word">代</div>
                                    </div>
                                    {/*  <view wx:if="{{ coupon.status == 1 }}" class="use-btn" catchtap="gotoTransferPage" style={convertLineStyleData('{{ 'background-color:' + coupon.list_color }}')}>立即买单</view>  */}
                                    {coupon.status == 2 ? (
                                      <div className="use-btn">已使用</div>
                                    ) : (
                                      coupon.status == 3 && (
                                        <div className="use-btn">已失效</div>
                                      )
                                    )}
                                  </div>
                                ) : coupon.type == 3 ? (
                                  <div
                                    className="top-section"
                                    style={convertLineStyleData('border-color:' + coupon.list_color)}
                                  >
                                    <div className="detail-info">
                                      <div className="name">{coupon.title}</div>
                                      {coupon.extra_condition == '' ? (
                                        <div className="use-condition">
                                          {'使用条件: 直接兑换' +
                                          coupon.coupon_goods_info.title}
                                        </div>
                                      ) : coupon.extra_condition.price ? (
                                        <div className="use-condition">
                                          {'使用条件: 消费满' +
                                          coupon.extra_condition.price +
                                          '元可兑换' +
                                          coupon.coupon_goods_info.title}
                                        </div>
                                      ) : (
                                        coupon.extra_condition.goods_id && (
                                          <div className="use-condition">
                                            {'使用条件: 购买' +
                                            coupon.condition_goods_info.title +
                                            '可兑换' +
                                            coupon.coupon_goods_info.title}
                                          </div>
                                        )
                                      )}
                                    </div>
                                    <div
                                      className="background-word-area"
                                      style={convertLineStyleData('border-color:' + coupon.list_color)}
                                    >
                                      <div
                                        className="background-circle"
                                        style={convertLineStyleData('background-color:' + coupon.list_color)}
                                      ></div>
                                      <div className="background-word">兑</div>
                                    </div>
                                    {coupon.status == 2 ? (
                                      <div className="use-btn">已使用</div>
                                    ) : (
                                      coupon.status == 3 && (
                                        <div className="use-btn">已失效</div>
                                      )
                                    )}
                                  </div>
                                ) : coupon.type == 4 ? (
                                  <div
                                    className="top-section"
                                    style={convertLineStyleData('border-color:' + coupon.list_color)}
                                  >
                                    <div className="detail-info">
                                      <div className="name">{coupon.title}</div>
                                      <div className="use-condition">
                                        {'使用条件: 储值金可充值' + coupon.value + '元'}
                                      </div>
                                    </div>
                                    <div
                                      className="background-word-area"
                                      style={convertLineStyleData('border-color:' + coupon.list_color)}
                                    >
                                      <div
                                        className="background-circle"
                                        style={convertLineStyleData('background-color:' + coupon.list_color)}
                                      ></div>
                                      <div className="background-word">储</div>
                                    </div>
                                    {coupon.status == 1 ? (
                                      <div
                                        className="use-btn"
                                        onClick={this.gotoRecharge}
                                        data-id={coupon.id}
                                        style={convertLineStyleData('background-color:' + coupon.list_color)}
                                      >
                                        立即充值
                                      </div>
                                    ) : coupon.status == 2 ? (
                                      <div className="use-btn">已使用</div>
                                    ) : (
                                      coupon.status == 3 && (
                                        <div className="use-btn">已失效</div>
                                      )
                                    )}
                                  </div>
                                ) : coupon.type == 5 ? (
                                  <div
                                    className="top-section"
                                    style={convertLineStyleData('border-color:' + coupon.list_color)}
                                  >
                                    <div className="detail-info">
                                      <div className="name">{coupon.title}</div>
                                      <div className="use-condition">
                                        {'使用条件: ' + coupon.extra_condition}
                                      </div>
                                    </div>
                                    <div
                                      className="background-word-area"
                                      style={convertLineStyleData('border-color:' + coupon.list_color)}
                                    >
                                      <div
                                        className="background-circle"
                                        style={convertLineStyleData('background-color:' + coupon.list_color)}
                                      ></div>
                                      <div className="background-word">通</div>
                                    </div>
                                    {coupon.status == 1 ? (
                                      <div
                                        className="use-btn"
                                        onClick={this.gotoCouponDetail}
                                        data-id={coupon.id}
                                        style={convertLineStyleData('background-color:' + coupon.list_color)}
                                      >
                                        立即使用
                                      </div>
                                    ) : coupon.status == 2 ? (
                                      <div className="use-btn">已使用</div>
                                    ) : (
                                      coupon.status == 3 && (
                                        <div className="use-btn">已失效</div>
                                      )
                                    )}
                                  </div>
                                ) : (
                                  coupon.type == 6 && (
                                    <div
                                      className="top-section"
                                      style={convertLineStyleData('border-color:' + coupon.list_color)}
                                    >
                                      <div className="detail-info">
                                        <div className="name">{coupon.title}</div>
                                        <div className="use-condition">
                                          {'使用条件: 可使用' +
                                          coupon.verify_times +
                                          '次'}
                                        </div>
                                      </div>
                                      <div
                                        className="background-word-area"
                                        style={convertLineStyleData('border-color:' + coupon.list_color)}
                                      >
                                        <div
                                          className="background-circle"
                                          style={convertLineStyleData(
                                            'background-color:' + coupon.list_color
                                          )}
                                        ></div>
                                        <div className="background-word">次</div>
                                      </div>
                                      {coupon.status == 1 ? (
                                        <div
                                          className="use-btn"
                                          onClick={(e) => this.gotoNumberPage(e)}
                                          data-id={coupon.id}
                                          data-appid={coupon.app_id}
                                          style={convertLineStyleData(
                                            'background-color:' + coupon.list_color
                                          )}
                                          data-untimes={coupon.un_verify_times}
                                        >
                                          立即使用
                                        </div>
                                      ) : coupon.status == 2 ? (
                                        <div className="use-btn">已使用</div>
                                      ) : coupon.status == 3 ? (
                                        <div className="use-btn">已失效</div>
                                      ) : (
                                        coupon.status == 4 && (
                                          <div className="use-btn">未生效</div>
                                        )
                                      )}
                                    </div>
                                  )
                                )}
                                <div className="bottom-section">
                                  <div>
                                    {'有效期 ' +
                                    (coupon.expire == '-1'
                                      ? coupon.start_use_date +
                                      '至' +
                                      coupon.end_use_date
                                      : coupon.expire == '0'
                                        ? '领取当天生效,有效期1天'
                                        : '领取' +
                                        (coupon.react > 0
                                          ? coupon.react + '天后'
                                          : '当天') +
                                        '生效，有效期' +
                                        coupon.expire +
                                        '天') +
                                    ' ' +
                                    (coupon.exclude_holiday == 0
                                      ? ''
                                      : '除去法定节假日') +
                                    ' ' +
                                    (coupon.exclude_weekend == 0
                                      ? ''
                                      : '周一至周五') +
                                    ' ' +
                                    coupon.start_use_time +
                                    '-' +
                                    coupon.end_use_time}
                                  </div>
                                </div>
                              </div>
                            </React.Fragment>
                          )
                        })}
                      </ScrollView>
                    </React.Fragment>
                  )}
                  <div
                    className={'zc-toast-bg ' + (rechargeSuccess == 1 ? 'show' : '')}
                    onClick={this.hideToast}
                  >
                    <div className="zc-toast">
                      <span className="icon" type="success" size="20"></span>
                      <div className="title">充值成功!</div>
                      <div className="content">请到储值金中查看</div>
                    </div>
                  </div>
                  <Modal
                    className="modal-wrap"
                    transparent
                    title="请输入本次核销次数"
                    visible={!hiddenmodalput}
                    maskClosable={true}
                    >
                    <input
                      className="modal-input"
                      type="number"
                      placeholder="请输入本次核销次数"
                      maxLength="6"
                      onInput={(e) => this.addLabelInputChange(e)}
                      focus={labelFocus}
                      style={convertLineStyleData('background:#F5F5F5;height:76rpx;border-radius:10rpx;padding: 0 60rpx')}
                    />
                    <div className="modal-btn-wrap">
                      <Button className="cancel" onClick={this.cancel}>取消</Button>
                      <Button className="confirm" onClick={this.confirm}>确认</Button>
                    </div>
                  </Modal>
                  </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/coupon-list/CouponList.jsx